import {
  Breadcrumbs,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  OutlinedInput,
} from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useBoundStore } from "store/store";
import i18n from "i18n/i18n";
import {
  Avatar,
  Badge,
  Button,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
  Popover,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import { ReactComponent as AvatarExample } from "assets/Svgs/user-avatar.svg";
import { AnySoaRecord } from "dns";
import React, { useEffect, useState } from "react";
import { getFileExtention, images_enum, isValidEmail } from "utils/helper";
import Axios from "apis/axios";
import { NodeId } from "components/NodeId";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import DeletePopUp from "components/DeletePopup";
import axios from "axios";
import { base_url, config_url } from "../../constants";
import { Visibility, VisibilityOff } from "@mui/icons-material";

function AddUser() {
  const location = useLocation();
  const lang: any = useBoundStore((state) => state.lang);

  const navigate = useNavigate();

  const createUser = useBoundStore((state) => state.createUser);

  const user: any = useBoundStore((state) => state.user);

  const profiles: any = useBoundStore((state) => state.profiles);
  const isAuthUser = useBoundStore((state) => state.isAuthUser);
  const userNodeId = location.state?.user?.nodeid;

  const setLang = useBoundStore((state) => state.setLang);

  let editMode = location.state?.pageType === "edit";

  const updateUser = useBoundStore((state) => state.updateUser);

  const [anchorEl, setAnchorEl] = React.useState<any>(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseAnchoeEl = () => {
    setAnchorEl(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const [Image, setImage] = useState<any>(null);
  const [mobilephone, setmobilephone] = useState("");
  const [landlinephone, setlandlinephone] = useState("");
  const [userStatus, setUserStatus] = useState<any>("");

  const [email, setemail] = useState("");

  const [givenname, setgivenname] = useState("");
  const [surname, setsurname] = useState("");

  const [ImageFile, setImageFile] = useState<any>(null);
  const [fileid, setfileid] = useState("");
  const [bucketid, setbucketid] = useState();
  const [uploadurl, setuploadurl] = useState();
  const [resourceLanguage, setResourceLanguage] = useState("de");
  const [mimetype, setmimetype] = useState("");
  const [nodeid, setnodeid] = useState<any>();
  const [fileVersion, setFileVersion] = useState();

  const legalEntityNodeId = useBoundStore((state) => state.legalEntityNodeId);

  const [fileId, setFileId] = useState();

  const deleteUser: any = useBoundStore((state) => state.deleteUser);
  const [equipmentPhotoObj, setEquipmentPhotoObj] = useState<any>();
  const [equipmentPhoto, setEquipmentPhoto] = useState("");
  const [validEmail, setValidEmail] = useState(false);
  const [profileid, setProfileId] = useState("");

  const [emailError, setEmailError] = useState(false);
  const sendResetPasswordLink = useBoundStore(
    (store) => store.sendResetPasswordLink
  );
  const [loader, setLoader] = useState(false);
  const acl_users: any = useBoundStore((state) => state.acl_users);


  const handleResetPasswordLink = async () => {
    setLoader(true);
    const promises: any[] = [sendResetPasswordLink(email)];

    try {
      const result = await Promise.all(promises);
      setTimeout(() => {
        navigate("/qualitymanagement");
      }, 2000);
    } catch (error) {
      console.error("Error during Promise.all:", error);
      // Handle the error appropriately
    }
  };



  const handleResourceLanguageChange = (e: any) => {
    setResourceLanguage(e.target.value);
  };

  useEffect(() => {
    if (editMode) {
      setnodeid(location.state.user?.nodeid);
      setgivenname(location.state.user.givenname || "");
      setsurname(location.state.user.surname || "");
      setemail(location.state.user.email || "");
      setmobilephone(location.state.user.mobilephone || "");
      setlandlinephone(location.state.user.landlinephone || "");
      setImage(location.state.user.image.url || null);
      setUserStatus("" + location.state.user.active || null);
      setEquipmentPhoto(
        location.state?.user?.image?.url ? location.state?.user?.image?.url : ""
      );
      setProfileId(location.state?.user?.userType);

      if(location.state?.user){

        let targetUser = acl_users.filter((user:any)=> { return user?.user?.usernodeid === location.state?.user?.nodeid});
        if(targetUser?.length){
          setResourceLanguage(targetUser[0]?.user?.userinfo?.lang);
        }
      }

      
      setEmailError(false);
      setValidationError(false);
    } else {
      setnodeid(uuidv4());
    }
  }, []);

  const handleNewImage = async (e: any) => {
    e.preventDefault();

    handleCloseAnchoeEl();

    var image = e.target.files[0];

    const exstention = getFileExtention(image?.type);
    if (e.target.files.length > 0) {
      const file = URL.createObjectURL(e.target.files[0]);
      setEquipmentPhoto(file);
      setEquipmentPhotoObj(image);

      const user_token: any = sessionStorage.getItem("accessToken");
      const url = base_url + "api/v1/files";

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + (user_token),
        },
      };

      const exstension_payload = [];

      if (location?.state?.pageType == "edit") {
        exstension_payload.push({
          nodeid: nodeid,
          extension: exstention,
          fileid: fileId,
        });
      } else {
        exstension_payload.push({
          nodeid: config_url + nodeid,
          extension: exstention,
        });
      }

      const response = axios
        .post(
          url,
          {
            count: 1,
            extensions: exstension_payload,
          },
          config
        )
        .then((res) => {
          var arr = [];
          const fileid = res.data[0].fileid;
          const uploadurl = res.data[0].url;
          const bucketid = res.data[0].bucketid;
          arr.push(fileid);
          arr.push(uploadurl);
          arr.push(image);
          arr.push(bucketid);
          arr.push(nodeid);
          arr.push(res.data[0].fileversion);
          receiveChildValue(arr);
          return res;
        })
        .catch(function (error) {});
      return response;
    }
  };

  const receiveChildValue = (value: any) => {
    const fileid = value[0];
    const uploadurl = value[1];
    const child_image = value[2];

    setmimetype(child_image.type);
    setfileid(fileid);
    setuploadurl(uploadurl);
    setEquipmentPhotoObj(child_image);
    setbucketid(value[3]);
    setFileVersion(value[5]);
  };

  const handleMobile = (e: any) => {
    setmobilephone(e.target.value);
  };

  const handleLandLine = (e: any) => {
    setlandlinephone(e.target.value);
  };
  const handleChangeUserStatus = (e: any) => {
    setUserStatus(e.target.value);
  };

  const handleChangeProfile = (e: any) => {
    setUserStatus(e.target.value);
  };

  const handleDeletePhoto = () => {
    setEquipmentPhoto("");
    setEquipmentPhotoObj("");
    handleCloseAnchoeEl();
  };

  const handleAddUser = async () => {
    let image;
    if (equipmentPhoto !== "") {
      let url: any = uploadurl;
      const config = {
        headers: {
          "Content-Type": equipmentPhotoObj.type,
          "Access-Control-Allow-Origin": "*",
        },
      };

      const response = await axios
        .put(url, equipmentPhotoObj, config)
        .then((res) => {})
        .catch(function (error) {});

      image = {
        fileid: fileid,
        mimetype: mimetype,
        bucketid: bucketid,
        fileversion: fileVersion,
      };
    }

    const userData = {
      givenname: givenname,
      surname: surname,
      mobilephone: mobilephone,
      landlinephone: landlinephone,
      email: email,
      active: userStatus === "true",
      image: image,
      legalentitynodeid: legalEntityNodeId,
      profileid: profileid,
      password: newPassword,
      nodeid: config_url + nodeid,
      clientid: localStorage.getItem("clientid"),
      lang: resourceLanguage,
    };

    const promises: any[] = [createUser(userData)]; // Ensure that promises is an array

    if (isAuthUser === true) {
      try {
        const result = await Promise.all(promises);
        setTimeout(() => {
          navigate("/users");
        }, 2000);
      } catch (error) {
        console.error("Error during Promise.all:", error);
        // Handle the error appropriately
      }
    }
  };

  const handleUpdateUser = async () => {
    let image;
    if (equipmentPhotoObj != undefined) {
      let url: any = uploadurl;
      const config = {
        headers: {
          "Content-Type": equipmentPhotoObj.type,
          "Access-Control-Allow-Origin": "*",
        },
      };

      const response = await axios
        .put(url, equipmentPhotoObj, config)
        .then((res) => {})
        .catch(function (error) {});

      image = {
        fileid: fileid,
        mimetype: mimetype,
        bucketid: bucketid,
        fileversion: fileVersion,
      };
    }

    const userData = {
      givenname: givenname,
      surname: surname,
      mobilephone: mobilephone,
      landlinephone: landlinephone,
      email: email,
      active: userStatus === "true",
      image: image,
      legalentitynodeid: legalEntityNodeId,
      profileid: profileid,
      password: "",
      userNodeId: userNodeId,

      clientid: localStorage.getItem("clientid"),
      lang: resourceLanguage,
    };

    const promises: any[] = [updateUser(userData)]; // Ensure that promises is an array

    if (isAuthUser === true) {
      try {
        const result = await Promise.all(promises);
        setTimeout(() => {
          navigate("/users");
        }, 1500);
      } catch (error) {
        console.error("Error during Promise.all:", error);
        // Handle the error appropriately
      }
    }
  };

  const [openDialogDelete, setopenDialogDelete] = useState(false);

  const handleDialogDelete = () => {
    setopenDialogDelete(false);
  };

  const handleDelete = async () => {
    const promises: any[] = [deleteUser(userNodeId)]; // Ensure that promises is an array

    if (isAuthUser === true) {
      try {
        const result = await Promise.all(promises);

        setopenDialogDelete(false);
        setTimeout(() => {
          navigate("/users");
        }, 1500);
      } catch (error) {
        console.error("Error during Promise.all:", error);
        // Handle the error appropriately
      }
    }
  };

  const handleChangeProfileID = (e: any) => {
    setProfileId(e.target.value);
  };

  const [values, setValues] = React.useState<any>({
    showPassword: false,
    showNewPassword: false,
  });

  const [newPassword, setNewPassword] = useState("");
  const [validationError, setValidationError] = useState(false);
  const [validationErrorMessage, setValidationErrorMessage] = useState("");
  const [cnfrmNewPassword, setCnfrmNewPassword] = useState("");

  const handleClickShowPassword = (name: any) => {
    setValues({ ...values, [name]: !values[name] });
  };

  const handleMouseDownPassword = (event: any) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (!editMode && email.length && !email.includes("@")) {
      setEmailError(false);
      if (newPassword !== cnfrmNewPassword) {
        setValidationError(true);
        setValidationErrorMessage(i18n(lang).pass_not_match);
        return;
      } else {
        setValidationError(false);
        setValidationErrorMessage("");
      }

      // validate Reges only for NePassword Field
      const reg = new RegExp(
        "(?=[A-Za-z0-9@#$%^&+!=]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.{8,}).*$"
      ); // min 8 characters , one uppercase and one lowercase is must
      if (reg.test(newPassword)) {
        setValidationError(false);
        setValidationErrorMessage("");
      } else {
        setValidationError(true);
        setValidationErrorMessage(i18n(lang).password_validation_error);
      }
    } else {
      if (email.includes("@")) {
        let isvalidemail = isValidEmail(email);
        setEmailError(!isvalidemail);
      } else {
        setEmailError(false);
      }
      setValidationError(false);
    }
  }, [newPassword, cnfrmNewPassword, email]);

  return (
    <div className="add_user">
      <Breadcrumbs aria-label="breadcrumb">
        <div
          onClick={() => {
            navigate(-1);
          }}
          style={{
            color: "rgba(0, 0, 0, 0.38)",
            display: "flex",
            cursor: "pointer",
            margin: "15px 0px",
          }}
        >
          <ArrowBackIcon />
          {i18n(lang).backLink}
        </div>
      </Breadcrumbs>

      <DeletePopUp
        open={openDialogDelete}
        handleClose={handleDialogDelete}
        handleDelete={handleDelete}
      ></DeletePopUp>

      <div className="userPage">
        <section>
          <Paper>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "24px",
                alignItems: "center",
              }}
            >
              <div className="_title">
                {editMode ? i18n(lang).edit_users : i18n(lang).add_new_user}
              </div>
              <div>
                {editMode ? (
                  <Button
                    variant="contained"
                    color="error"
                    size="large"
                    startIcon={<DeleteForeverOutlinedIcon />}
                    onClick={() => {
                      setopenDialogDelete(true);
                    }}
                    sx={{
                      width: "100%",
                      color: "rgba(255, 61, 0, 1)",
                      border: "1px solid rgba(0, 0, 0, 0.12)",
                      borderRadius: "4px",
                      background: "#ffffff",
                      ":hover": { color: "#ffffff" },
                      boxShadow: "none",
                    }}
                  >
                    {i18n(lang).user} {i18n(lang).delete}
                  </Button>
                ) : (
                  ""
                )}
              </div>
            </div>

            <form style={{ padding: "24px" }}>
              <Grid
                container
                spacing={3}
                direction="row"
                justifyContent="space-between"
              >
                <Grid item xs={9}>
                  <Grid item xs={12}>
                    <Grid container spacing={3} sx={{ paddingBottom: "24px" }}>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          value={givenname}
                          onChange={(e: any) => setgivenname(e.target.value)}
                          label={i18n(lang)?.first_name}
                          variant="outlined"
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          value={surname}
                          onChange={(e: any) => setsurname(e.target.value)}
                          label={i18n(lang)?.last_name}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                    {/* for admin */}
                    <Grid container spacing={3} sx={{ paddingBottom: "24px" }}>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          onChange={(e: any) => setemail(e.target.value)}
                          label={i18n(lang)?.email}
                          value={email}
                          error={emailError}
                          variant="outlined"
                          disabled={editMode}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={3} sx={{ paddingBottom: "24px" }}>
                      <Grid item xs={6}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel id="role-label">
                            User-Account-Status
                          </InputLabel>
                          <Select
                            fullWidth
                            labelId="role-label"
                            label={"User-Account-Status"}
                            defaultValue={null}
                            value={userStatus}
                            onChange={handleChangeUserStatus}
                          >
                            <MenuItem value={"true"}>{"aktiviert"}</MenuItem>

                            <MenuItem value={"false"}>{"Inaktiviert"}</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={6}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel id="role-label">
                            {i18n(lang).role}
                          </InputLabel>
                          <Select
                            fullWidth
                            labelId="role-label"
                            label={i18n(lang)?.role}
                            defaultValue={profileid}
                            value={profileid}
                            onChange={handleChangeProfileID}
                          >
                            {profiles &&
                              profiles?.map((profile: any) => {
                                return (
                                  <MenuItem value={profile.id}>
                                    {profile.name[lang]}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                      {
                        <>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              label={i18n(lang).phone_number_mobile}
                              defaultValue={user?.mobilephone || ""}
                              value={mobilephone}
                              onChange={handleMobile}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              label={i18n(lang).landline_number_optional}
                              defaultValue={user?.landlinephone || ""}
                              value={landlinephone}
                              onChange={handleLandLine}
                            />
                          </Grid>
                        </>
                      }
                    </Grid>

                    {/* for non-admin */}
                  </Grid>

                  <Grid container spacing={3} sx={{ paddingTop: "24px" }}>
                    <Grid item xs={6}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel id="role-label">
                          {i18n(lang)?.resource_language}
                        </InputLabel>
                        <Select
                          fullWidth
                          labelId="role-label"
                          label={i18n(lang)?.resource_language}
                          defaultValue={""}
                          // error={resourceLanguage === ""}
                          value={resourceLanguage}
                          onChange={handleResourceLanguageChange}
                        >
                          <MenuItem value={"de"}>{"Deutsch"}</MenuItem>
                          <MenuItem value={"en"}>{"English"}</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleCloseAnchoeEl}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <Paper sx={{ width: 250, maxWidth: "100%" }}>
                    <MenuList>
                      <label htmlFor="myInput">
                        <MenuItem>
                          <ListItemIcon>
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7 14C6.71667 14 6.47933 13.904 6.288 13.712C6.096 13.5207 6 13.2833 6 13V8H1C0.716667 8 0.479 7.904 0.287 7.712C0.0956668 7.52067 0 7.28333 0 7C0 6.71667 0.0956668 6.479 0.287 6.287C0.479 6.09567 0.716667 6 1 6H6V1C6 0.716667 6.096 0.479 6.288 0.287C6.47933 0.0956668 6.71667 0 7 0C7.28333 0 7.521 0.0956668 7.713 0.287C7.90433 0.479 8 0.716667 8 1V6H13C13.2833 6 13.5207 6.09567 13.712 6.287C13.904 6.479 14 6.71667 14 7C14 7.28333 13.904 7.52067 13.712 7.712C13.5207 7.904 13.2833 8 13 8H8V13C8 13.2833 7.90433 13.5207 7.713 13.712C7.521 13.904 7.28333 14 7 14Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                            </svg>
                          </ListItemIcon>
                          <ListItemText>
                            {i18n(lang).upload_new_photo}
                          </ListItemText>
                          <ListItemButton>
                            <input
                              id="myInput"
                              style={{ display: "none" }}
                              type={"file"}
                              accept={images_enum}
                              onChange={handleNewImage}
                            />
                          </ListItemButton>
                        </MenuItem>
                      </label>
                    </MenuList>
                    <Divider />
                    <MenuList>
                      <MenuItem onClick={handleDeletePhoto}>
                        <ListItemIcon>
                          <svg
                            width="16"
                            height="18"
                            viewBox="0 0 16 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3 18C2.45 18 1.97933 17.8043 1.588 17.413C1.196 17.021 1 16.55 1 16V3C0.716667 3 0.479 2.90433 0.287 2.713C0.0956668 2.521 0 2.28333 0 2C0 1.71667 0.0956668 1.479 0.287 1.287C0.479 1.09567 0.716667 1 1 1H5C5 0.716667 5.096 0.479 5.288 0.287C5.47933 0.0956666 5.71667 0 6 0H10C10.2833 0 10.521 0.0956666 10.713 0.287C10.9043 0.479 11 0.716667 11 1H15C15.2833 1 15.5207 1.09567 15.712 1.287C15.904 1.479 16 1.71667 16 2C16 2.28333 15.904 2.521 15.712 2.713C15.5207 2.90433 15.2833 3 15 3V16C15 16.55 14.8043 17.021 14.413 17.413C14.021 17.8043 13.55 18 13 18H3ZM3 3V16H13V3H3ZM8 10.9L9.9 12.8C10.1 12.9833 10.3377 13.075 10.613 13.075C10.8877 13.075 11.1167 12.9833 11.3 12.8C11.5 12.6 11.6 12.3623 11.6 12.087C11.6 11.8123 11.5 11.5833 11.3 11.4L9.4 9.5L11.3 7.6C11.5 7.4 11.6 7.16233 11.6 6.887C11.6 6.61233 11.5 6.38333 11.3 6.2C11.1167 6 10.8877 5.9 10.613 5.9C10.3377 5.9 10.1 6 9.9 6.2L8 8.1L6.1 6.2C5.91667 6 5.68767 5.9 5.413 5.9C5.13767 5.9 4.9 6 4.7 6.2C4.51667 6.38333 4.425 6.61233 4.425 6.887C4.425 7.16233 4.51667 7.4 4.7 7.6L6.6 9.5L4.7 11.4C4.51667 11.5833 4.425 11.8123 4.425 12.087C4.425 12.3623 4.51667 12.6 4.7 12.8C4.9 12.9833 5.13767 13.075 5.413 13.075C5.68767 13.075 5.91667 12.9833 6.1 12.8L8 10.9Z"
                              fill="#FF3D00"
                            />
                          </svg>
                        </ListItemIcon>
                        <ListItemText>{i18n(lang).delete_photo}</ListItemText>
                      </MenuItem>
                    </MenuList>
                  </Paper>
                </Popover>

                <Grid item xs={3} sx={{ textAlign: "center" }}>
                  <Badge
                    overlap="circular"
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    badgeContent={
                      <IconButton
                        sx={{
                          backgroundColor: "white",
                          width: "40px",
                          height: "40px",
                        }}
                        className="bxShadow iconBadge"
                        edge="start"
                        onClick={handleClick}
                      >
                        {Image !== AvatarExample ? (
                          <div>
                            {" "}
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_2958_6"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="24"
                                height="24"
                              >
                                <rect width="24" height="24" fill="#D9D9D9" />
                              </mask>
                              <g mask="url(#mask0_2958_6)">
                                <path
                                  d="M5 19H6.4L15.025 10.375L13.625 8.975L5 17.6V19ZM19.3 8.925L15.05 4.725L16.45 3.325C16.8333 2.94167 17.3043 2.75 17.863 2.75C18.421 2.75 18.8917 2.94167 19.275 3.325L20.675 4.725C21.0583 5.10833 21.2583 5.571 21.275 6.113C21.2917 6.65433 21.1083 7.11667 20.725 7.5L19.3 8.925ZM4 21C3.71667 21 3.47933 20.904 3.288 20.712C3.096 20.5207 3 20.2833 3 20V17.175C3 17.0417 3.025 16.9127 3.075 16.788C3.125 16.6627 3.2 16.55 3.3 16.45L13.6 6.15L17.85 10.4L7.55 20.7C7.45 20.8 7.33767 20.875 7.213 20.925C7.08767 20.975 6.95833 21 6.825 21H4Z"
                                  fill="rgba(0, 0, 0, 0.87)"
                                />
                              </g>
                            </svg>
                          </div>
                        ) : (
                          <div>
                            {" "}
                            <label htmlFor="myInputFirst">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask
                                  id="mask0_2958_839"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="24"
                                  height="24"
                                >
                                  <rect width="24" height="24" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_2958_839)">
                                  <path
                                    d="M6 20C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18V15H6V18H18V15H20V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H6ZM11 16V7.85L8.4 10.45L7 9L12 4L17 9L15.6 10.45L13 7.85V16H11Z"
                                    fill="rgba(0, 0, 0, 0.87)"
                                  />
                                </g>
                              </svg>

                              <input
                                id="myInputFirst"
                                style={{ display: "none" }}
                                type={"file"}
                                accept={images_enum}
                              />
                            </label>
                          </div>
                        )}
                      </IconButton>
                    }
                  >
                    <div
                      style={{
                        width: "101px",
                        height: "101px",
                      }}
                    >
                      {equipmentPhoto !== "" ? (
                        <img
                          className="bxShadow"
                          src={equipmentPhoto}
                          width={100}
                          height={100}
                          style={{ borderRadius: "50%" }}
                        />
                      ) : (
                        <AvatarExample width={100} height={100} />
                      )}
                    </div>
                  </Badge>
                </Grid>

                <br />
                <br />
              </Grid>
            </form>
            <Divider orientation="horizontal" />
          </Paper>
        </section>

        <div>
          <Button
            variant="contained"
            className="saveProfile"
            sx={{
              backgroundColor: "var(--primary-color)",
              margin: "15px 0px",
            }}
            onClick={() => (editMode ? handleUpdateUser() : handleAddUser())}
            disabled={
              givenname === "" ||
              email === "" ||
              userStatus === "" ||
              // mobilephone === "" ||
              validationError ||
              emailError
            }
          >
            {editMode ? i18n(lang).edit_users : i18n(lang).add_new_user}
          </Button>
          {loader ? <CircularProgress /> : ""}

         { 
          editMode
          ? <Button
            variant="contained"
            className="saveProfile"
            sx={{
              backgroundColor: "var(--primary-color)",
              margin: "15px 20px",
            }}
            onClick={() => handleResetPasswordLink()}
            disabled={
              givenname === "" ||
              email === "" ||
              userStatus === "" ||
              // mobilephone === "" ||
              validationError ||
              emailError
            }
          >
            {i18n(lang).password_reset_link}
          </Button> : "" }
        </div>
      </div>
    </div>
  );
}

export default AddUser;
